import Case from 'case';

type EnumType = Record<string, string>;

const normalizeEnum = (from: EnumType) => {
  const normal: EnumType = {};
  for (const k in from) {
    normal[Case.constant(k)] = from[k];
  }
  return normal;
}

export const mapEnum = <T extends EnumType, V extends EnumType>(from: T, to: V, valueFrom?: string) => {
  const normalFromEnum = normalizeEnum(from);
  const normalToEnum = normalizeEnum(to);
  let normalFromKey: string | null = null;
  for (const k in normalFromEnum) {
    if (normalFromEnum[k] === valueFrom || normalToEnum[k] === valueFrom) {
      normalFromKey = k;
    }
  }
  if (normalFromKey && normalFromKey in normalToEnum) {
    return normalToEnum[normalFromKey] as unknown as V[Extract<keyof V, string>];
  }
}